export const newsList = [
  {
    id: "news-muse-premiere",
    dramaId: "mu-se-hui-sheng",
    title: "《暮色回声》开播即登顶，悬疑赛道再添口碑黑马",
    summary:
      "开播首周热度登顶，《暮色回声》凭扎实的剧本与克制的氛围，被观众称为今年最耐看的都市悬疑剧，江砚与苏黎的组合更是圈粉无数。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20suspense%20series%20still%2C%20rainy%20night%20city%20street%20with%20detective%20silhouette%20in%20navy%20coat%2C%20deep%20navy%20blue%20with%20warm%20orange%20streetlight%2C%20moody%20atmospheric%20lighting%2C%20editorial%20photography%20style%2C%20no%20text&width=800&height=500&seq=news-muse&orientation=landscape",
    date: "2024-09-25",
    tag: "开播速递",
  },
  {
    id: "news-xingchen-trailer",
    dramaId: "xing-chen-zhi-yue",
    title: "《星尘之约》发布终极预告，宇宙告白片段引热议",
    summary:
      "四光年的延迟告白即将抵达地球。《星尘之约》终极预告上线，陆星野与林晚跨时空的对白戳中无数观众，科幻外壳下的深情成为最大看点。",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20film%20still%2C%20astronaut%20looking%20at%20glowing%20planet%20and%20nebula%2C%20deep%20navy%20space%20with%20warm%20orange%20starlight%2C%20cinematic%20dramatic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-xingchen&orientation=landscape",
    date: "2024-07-18",
    tag: "预告首发",
  },
  {
    id: "news-shanhai-aesthetic",
    dramaId: "shan-hai-huan-meng-lu",
    title: "《山海幻梦录》东方奇幻美学出圈，服化道细节获赞",
    summary:
      "从水墨山川到异兽造型，《山海幻梦录》用细腻的东方美学构建出独树一帜的幻梦世界，网友直呼“每一帧都是壁纸”。",
    cover:
      "https://readdy.ai/api/search-image?query=oriental%20fantasy%20series%20still%2C%20misty%20mythical%20mountains%20with%20floating%20islands%20and%20elegant%20robed%20figure%2C%20ink%20wash%20navy%20with%20soft%20gold%20accents%2C%20ethereal%20cinematic%20lighting%2C%20highly%20detailed%2C%20no%20text&width=800&height=500&seq=news-shanhai&orientation=landscape",
    date: "2024-06-10",
    tag: "美学解析",
  },
  {
    id: "news-meigui-growth",
    dramaId: "mei-gui-yu-jing-ji",
    title: "《玫瑰与荆棘》成长线引共鸣，职场女性话题升温",
    summary:
      "姜玫从裁缝铺走进时装行业的主线引发广泛讨论，剧中对女性独立与选择的描摹收获大量好评，相关话题连续多日登上热榜。",
    cover:
      "https://readdy.ai/api/search-image?query=stylish%20urban%20drama%20still%2C%20elegant%20woman%20in%20modern%20fashion%20atelier%20with%20draped%20fabric%2C%20deep%20navy%20and%20cream%20with%20warm%20orange%20accent%2C%20editorial%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=news-meigui&orientation=landscape",
    date: "2024-08-22",
    tag: "话题热议",
  },
  {
    id: "news-wusheng-finale",
    dramaId: "wu-sheng-zhi-cheng",
    title: "《无声之城》大结局反转不断，观众直呼没猜到",
    summary:
      "在大结局播出后，《无声之城》凭多次意想不到的反转登上热搜。韩默用眼睛读懂真相的设定，让这部剧在同类题材中别具一格。",
    cover:
      "https://readdy.ai/api/search-image?query=gritty%20crime%20thriller%20still%2C%20dark%20room%20with%20surveillance%20monitors%20and%20lone%20figure%2C%20cold%20navy%20blue%20with%20sharp%20orange%20monitor%20glow%2C%20tense%20moody%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=news-wusheng&orientation=landscape",
    date: "2024-07-08",
    tag: "结局讨论",
  },
  {
    id: "news-niliu-comeback",
    dramaId: "ni-liu-er-shang",
    title: "《逆流而上》谢知行跌破谷底，逆袭剧情燃爆全场",
    summary:
      "从被迫离场到重回牌桌，谢知行的逆袭线让《逆流而上》收视一路走高。剧中大量写实的行业细节，成为金融题材讨论的焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20corporate%20drama%20still%2C%20confident%20man%20in%20suit%20before%20city%20skyline%20at%20dawn%2C%20deep%20navy%20blue%20with%20warm%20orange%20sunrise%20accent%2C%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=news-niliu&orientation=landscape",
    date: "2024-05-06",
    tag: "剧情追踪",
  },
  {
    id: "news-chunfeng-scene",
    dramaId: "chun-feng-du-chang-an",
    title: "《春风渡长安》长安城场景醉人，古装美学再回潮",
    summary:
      "西市街景、折枝花鸟画与春日花瓣的细节处理，让《春风渡长安》成为近期最“上镜”的古装剧之一，取景与美术细节被反复截图分享。",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20drama%20still%2C%20palace%20city%20avenue%20in%20spring%20with%20blossom%20petals%20and%20lanterns%2C%20deep%20navy%20and%20soft%20gold%20tones%2C%20romantic%20ethereal%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=news-chunfeng&orientation=landscape",
    date: "2024-03-28",
    tag: "美术赏析",
  },
  {
    id: "news-zhuiguang-band",
    dramaId: "zhui-guang-zhe",
    title: "《追光者》乐队名场面出圈，青春励志治愈观众",
    summary:
      "天台演出与酒吧首秀两场戏接连出圈，《追光者》用清亮的青春故事打动了不少观众，周野与夏禾的坚持成为弹幕里最常被提到的关键词。",
    cover:
      "https://readdy.ai/api/search-image?query=youth%20music%20drama%20still%2C%20young%20band%20playing%20on%20small%20stage%20with%20glowing%20lights%2C%20deep%20navy%20blue%20with%20warm%20orange%20stage%20glow%2C%20energetic%20cinematic%20lighting%2C%20no%20text&width=800&height=500&seq=news-zhuiguang&orientation=landscape",
    date: "2024-02-20",
    tag: "青春现场",
  },
];